import type { ArchetypeGenerationResponse } from "../types/archetype";

export interface GenerateArchetypeInput {
  appName?: string;
  description?: string;
  packageName?: string;
}

export async function generateSimpleAppArchetype(
  input: GenerateArchetypeInput,
): Promise<ArchetypeGenerationResponse> {
  const response = await fetch("/api/studio/archetypes/simple-app/generate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });

  const payload = (await response.json()) as ArchetypeGenerationResponse;
  if (!response.ok || !payload?.ok) {
    const message = payload?.error ?? `Failed to generate archetype (status ${response.status})`;
    throw new Error(message);
  }

  return payload;
}

export async function fetchArchetypeMetadata(archetypeId: string): Promise<ArchetypeGenerationResponse> {
  if (!archetypeId?.trim()) {
    throw new Error("archetypeId is required");
  }

  const response = await fetch(`/api/studio/archetypes/${encodeURIComponent(archetypeId)}`);
  const payload = (await response.json()) as ArchetypeGenerationResponse;

  if (!response.ok || !payload?.ok) {
    const message = payload?.error ?? `Failed to load archetype metadata (status ${response.status})`;
    throw new Error(message);
  }

  return payload;
}
